// Copyright (c) 2023 Jürgen Gebath
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT
import { Grid, Typography } from "@mui/material";

function NoPage() {
  return (
    <Grid
      container
      spacing={2}
      sx={(theme) => ({
        [theme.breakpoints.down("sm")]: {
          marginTop: 7,
        },
        [theme.breakpoints.up("sm")]: {
          marginTop: 20,
        },
      })}
      justifyContent="center">
      <Grid
        item
        xs={12}>
        <Typography
          variant="h5"
          textAlign="center">
          Page not found
        </Typography>
      </Grid>
    </Grid>
  );
}

export default NoPage;
